/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../contexts/aniplus";
import { withRouter } from "react-router-dom";

class OnAirItem extends Component {
  render() {
    const { title, subTitle, outputStart, ratio, index } =
      this.props.childProps;
    return (
      <Fragment>
        {index === 0 ? (
          <div className="time_div" style={{ width: 489 }}>
            <div className="time_text">
              <em className="on_text">{outputStart.substr(0, 5)}</em>
              <p className="on_text">
                <img src="img/on.png" />
                {title}
                <span className="on_text">{subTitle}</span>
              </p>
              {/*<strong>{outputStart.substr(0, 5)}</strong>*/}
            </div>
            {ratio > 0 ? (
              <div
                style={{
                  backgroundColor: "#af0000",
                  width: ratio > 100 ? "100%" : ratio + "%",
                  position: "absolute",
                  height: "100%",
                  top: 0,
                }}
              ></div>
            ) : null}
          </div>
        ) : (
          <div className="time_div" style={{ width: 489 }}>
            <div className="time_text">
              <em>{outputStart.substr(0, 5)}</em>
              <p>
                {/*<img src="img/yeyag.png"/>*/}
                {title}
                <span>{subTitle}</span>
              </p>
              {/*<strong>{outputStart.substr(0, 5)}</strong>*/}
            </div>
          </div>
        )}

        {/*
                <div className="time_div">
                    <div className="time_text">
                        <em className="on_text">21:00</em>
                        <p className="on_text"><img src="img/on.png"/>오호츠키의 냉청<span className="on_text">15화. 마녀란 무엇인가 / 양장도락</span></p>
                        <strong>22:30</strong>
                    </div>
                    <div style={{backgroundColor: '#af0000', width: '50%', position: 'absolute', height: '100%', top: 0}}></div>
                </div>
                <div className="time_div">
                    <div className="time_text">
                        <em>21:00</em>
                        <p><img src="img/yeyag.png"/>오호츠키의 냉청<span>15화. 마녀란 무엇인가 / 양장도락</span></p>
                        <strong>22:30</strong>
                    </div>
                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(OnAirItem));
